var React = require('react');

function PacmanDivooraInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:#E20917;}\r\n"),React.createElement("path",{"id":"XMLID_1_","className":"st0","d":"M490.5,354.3L255,256l235.5-98.3C452.6,64.5,361.5,0,255,0C114.7,0,0,114.7,0,256\r\n\ts113.7,256,255,256C361.5,512,452.6,446.5,490.5,354.3z","key":1})]);
}

PacmanDivooraInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"512px","height":"512px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = PacmanDivooraInline;

PacmanDivooraInline.default = PacmanDivooraInline;
